var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHaveapartment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 77 90"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentcolor",
  strokeWidth: 2.56
}, /*#__PURE__*/React.createElement("path", {
  d: "m44.235 4.42 28.88 30.458a7.57 7.57 0 0 1 2.101 5.244v40.34c0 4.237-3.457 7.666-7.728 7.666H9.728c-4.27 0-7.728-3.43-7.728-7.665v-40.34c0-1.95.746-3.833 2.102-5.245L32.982 4.42c3.05-3.227 8.202-3.227 11.253 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.964 60.898h-15.32c-1.153 0-2.035-.874-2.035-2.017V43.618c0-1.143.882-2.017 2.034-2.017h15.39c1.152 0 2.033.874 2.033 2.017v15.263c-.068 1.075-.95 2.017-2.102 2.017ZM24.304 41.601v19.297M14.61 51.216h19.388M75.216 59.553H61.454c-3.796 0-6.847 3.025-6.847 6.79v21.785"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeLinejoin: "round",
  d: "M8.78 27.95V7.107c0-2.017 2.1-3.698 4.677-3.698h4.881c2.576 0 4.678 1.681 4.678 3.698v6.522"
}))));
export default SvgHaveapartment;